import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TableDataLayerAssigned from "../components/TableDataLayerAssigned";

const TableDataPageAssigned = () => {
  return (
    <>
      <MasterLayout>
        <TableDataLayerAssigned />
      </MasterLayout>
    </>
  );
};

export default TableDataPageAssigned;
